<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  categories: Array,
  dataBpr: Array,
  dataEnrl: Array,
  dataGraduates: Array,
  bigLawCategories: Array,
  dataBigLaw: Array,
  firmSize: Number,
})

onMounted(() => {
  const { firmSize, categories, dataBpr, dataEnrl, dataGraduates, bigLawCategories, dataBigLaw } = props

  new Highcharts.Chart({
    chart: { renderTo: "natlRates", zoomType: "xy" },
    title: { text: "Legal Jobs and 1L Enrollment" },
    subtitle: { text: "for ABA-Approved Schools" },
    xAxis: { categories, tickInterval: 2, labels: { rotation: 0, align: "center" }, crosshair: true },
    yAxis: [
      { // total 1Ls
        gridLineWidth: 1,
        title: { text: "", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        tickInterval: 10000,
        min: 0,
        max: 55000,
      },
    ],
    tooltip: {
      shared: true,
      formatter() {
        let s = `<b>${this.x}</b>`
        let enr
        let grads
        let jobs
        $.each(this.points, function () {
          const part = this.series._i

          if (part == 0) {
            jobs = this.y
          } else if (part == 1) {
            grads = this.y
          } else if (part == 2) {
            enr = this.y
          }
          s += `<br/><span style="color:${this.color}">\u25CF</span> ${this.series.name}: <b>${
            this.y}</b>`
        })

        s += `<br/>___<br/>1Ls to Legal Jobs Ratio: <b>${Math.round((enr / jobs) * 10) / 10}:1</b>`
        s += `<br/>Legal Job Rate: <b>${Math.round((jobs / grads) * 1000) / 10}%</b>`

        return s
      },
    },
    series:
      [
        { name: "Graduates Employed in Full-Time Legal Jobs", type: "spline", color: "#AA4643", marker: { enabled: false, symbol: "circle" }, yAxis: 0, data: dataBpr },
        { name: "Graduates", type: "spline", color: "#EA4643", marker: { enabled: false, symbol: "circle" }, yAxis: 0, data: dataGraduates },
        { name: "1L Enrollment", type: "spline", color: "#4572A7", marker: { enabled: false, symbol: "circle" }, yAxis: 0, data: dataEnrl },
      ],
  })

  new Highcharts.Chart({
    chart: { renderTo: "biglaw", zoomType: "xy" },
    title: { text: `Jobs at large law firms with > ${firmSize} attorneys` },
    legend: { enabled: false },
    subtitle: { text: "for ABA-Approved Schools" },
    xAxis: { categories: bigLawCategories, tickInterval: 4, labels: { rotation: 0, align: "center" }, crosshair: true },
    yAxis: [
      { // total
        gridLineWidth: 1,
        title: { text: "", style: { color: "#4572A7" } },
        labels: { formatter() {
                    return `${this.value / 1000}k`
                  },
                  style: { color: "#4572A7" } },
        opposite: false,
        endOnTick: true,
        tickInterval: 2000,
        min: 0,
        max: 10000,
      },
    ],
    tooltip: {
      shared: false,
    },
    series:
      [
        {
          name: `Jobs at large law firms with > ${firmSize} attorneys`,
          type: "spline",
          color: "#AA4643",
          marker: { enabled: false, symbol: "circle" },
          yAxis: 0,
          data: dataBigLaw,
        },
      ],
  })
})
</script>
